import React, { useRef, forwardRef, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { getYear, getMonth } from 'date-fns';
import { range } from 'lodash';

import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePicker.css';

const CustomDateRangeInput = forwardRef((props, ref) => {
  const { datePickerType, ...rest } = props
  return (<>
    <input
      type="text"
      ref={ref}
      {...rest}
      readOnly
      className={`cb-form-control efup-date-picker-read-only efup-date-picker-icon efup-date-picker-${datePickerType ? datePickerType : "default"}`}
      data-testid={`efup-date-picker-input-${datePickerType ? datePickerType : "default"}`}
    />
    <i {...rest} className="cb-icon icon-date_range efup-calendar-icon" ></i>
  </>);
});

const currentYear = getYear(new Date()) + 1;
const years = range(currentYear - 5, currentYear, 1);
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const DatePickerCustomHeader = ({
  date,
  changeYear,
  changeMonth,
  handleCalendarClose,
  shouldDisplayClose,
}) => (
  <>
    {shouldDisplayClose ? <div className="efup-date-picker-close">
      <i className="cb-icon icon-close" onClick={handleCalendarClose} data-testid="efup-date-picker-calendar-close"></i>
    </div> : <React.Fragment />}
    <div className="efup-month-year-dropdowns">
      <div className="date-range-select-wrapper" >
        <select
          value={months[getMonth(date)]}
          onChange={({ target: { value } }) =>
            changeMonth(months.indexOf(value))
          }
          className="date-range-selection"
          data-testid="efup-date-picker-calendar-month-dropdown"
        >
          {months.map((option) => (
            <option key={option} value={option} data-testid={`efup-date-picker-calendar-month-option-${option}`}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <div className="date-range-select-wrapper" >
        <select
          value={getYear(date)}
          onChange={({ target: { value } }) => changeYear(value)}
          className="date-range-selection"
          data-testid="efup-date-picker-calendar-year-dropdown"
        >
          {years.map((option) => (
            <option key={option} value={option} data-testid={`efup-date-picker-calendar-year-option-${option}`}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  </>);

const CustomDatePicker = props => {

  const refCustomDateRangeInput = useRef();
  const currentDate = new Date();

  function handleCalendarOpen() {
    if (props.setCalendarOpen) {
      props.setCalendarOpen(true);
    }
  }

  function handleCalendarClose() {
    if (props.setCalendarOpen) {
      props.setCalendarOpen(false);
    }
  }

  // When manually controlling open state, use a ref to keep focus
  const datepickerRef = useRef(null);
  useEffect(() => {
    if (props.isOpen) {
      datepickerRef.current.setFocus();
    }
  }, [props.isOpen]);

  const shouldDisplayClose = props.shouldDisplayClose;

  return (
    <div className={`efup-date-picker efup-date-picker-icon ${props.customClasses ? props.customClasses : ""}`} >
      <DatePicker
        selected={props.selectedDate}
        onChange={(date) => props.setDate(date)}
        startDate={props.startDate}
        placeholderText={props.placeholderText ? props.placeholderText : undefined}
        ref={datepickerRef}
        endDate={props.endDate}
        maxDate={props.type === 'range-start' && props.endDate ? props.endDate : currentDate}
        minDate={props.type === 'range-end' ? props.startDate : undefined}
        selectsStart={props.selectsStart}
        selectsEnd={props.selectsEnd}
        showPopperArrow={props.hidePopperArrow ? false : true}
        renderCustomHeader={(props) => <DatePickerCustomHeader handleCalendarClose={handleCalendarClose} shouldDisplayClose={shouldDisplayClose} {...props} />}
        onCalendarClose={handleCalendarClose}
        onCalendarOpen={handleCalendarOpen}
        onBlur={props.onBlur}
        open={props.isOpen ? props.isOpen : undefined}
        inline={props.inline}
        isClearable={props.isClearable && props.selectedDate}
        clearButtonClassName={props.type === 'range-start' ? "efup-date-range-clear-button efup-clear-correction" : "efup-date-range-clear-button"}
        customInput={<CustomDateRangeInput ref={refCustomDateRangeInput} datePickerType={props.type} />}
      />
    </div>
  );
};

export default CustomDatePicker;